const MuiSvgIcon = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { fontSizeLarge: { width: 32, height: 32, fontSize: 'inherit' } },
};

export const svgIcon = { MuiSvgIcon };
